import featureFlagValues from 'feature-flags';

export const isFeatureEnabled = (featureId) => {
  const stage = process.env.KOUTO_STAGE;
  return featureFlagValues[stage] && featureFlagValues[stage][featureId];
};
